var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3125 8C2.3125 6.49158 2.91172 5.04494 3.97833 3.97833C5.04494 2.91172 6.49158 2.3125 8 2.3125C9.50842 2.3125 10.9551 2.91172 12.0217 3.97833C13.0883 5.04494 13.6875 6.49158 13.6875 8C13.6875 9.50842 13.0883 10.9551 12.0217 12.0217C10.9551 13.0883 9.50842 13.6875 8 13.6875C6.49158 13.6875 5.04494 13.0883 3.97833 12.0217C2.91172 10.9551 2.3125 9.50842 2.3125 8ZM8 1C6.14349 1 4.36301 1.7375 3.05026 3.05026C1.7375 4.36301 1 6.14349 1 8C1 9.85649 1.7375 11.637 3.05026 12.9498C4.36301 14.2625 6.14349 15 8 15C9.85649 15 11.637 14.2625 12.9498 12.9498C14.2625 11.637 15 9.85649 15 8C15 6.14349 14.2625 4.36301 12.9498 3.05026C11.637 1.7375 9.85649 1 8 1ZM8.4375 5.15625C8.4375 4.9822 8.36836 4.81528 8.24529 4.69221C8.12222 4.56914 7.9553 4.5 7.78125 4.5C7.6072 4.5 7.44028 4.56914 7.31721 4.69221C7.19414 4.81528 7.125 4.9822 7.125 5.15625V8.21875C7.12503 8.34981 7.16431 8.47785 7.23775 8.5864C7.31121 8.69493 7.41547 8.779 7.53713 8.82775L9.72462 9.70275C9.88484 9.76129 10.0616 9.75507 10.2173 9.68554C10.3731 9.61598 10.4957 9.48851 10.559 9.33012C10.6224 9.17175 10.6216 8.99492 10.5568 8.8371C10.4921 8.6793 10.3684 8.55292 10.212 8.48475L8.4375 7.77425V5.15625Z",
    fill: "#0AE8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6b776901127f875ea3fb987f93a57f37.svg";
export { ForwardRef as ReactComponent };